import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evento-detalhe-dashboard',
  templateUrl: './evento-detalhe-dashboard.component.html',
  styleUrls: ['./evento-detalhe-dashboard.component.scss']
})
export class EventoDetalheDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
